export class GetOrderPendingInvoicingHistoryListInput {
  pending?: boolean;
  number?: string;
  stateId?: number;
  express?: boolean;
  newestFirst?: boolean;
  page?: number;
  pageSize?: number;
}
